import { Skeleton } from '@/components/ui/skeleton';
import { useTranslation } from '@/i18n';

/**
 * The shape of the account screen, while it loads.
 *
 * In place of the region being filled rather than a full-page `LoadingScreen`. Swapping the whole page throws
 * away the header the guest is already reading and makes the app look like it reloaded — a screen that keeps
 * its outline while the contents arrive reads as fast even when it is not.
 *
 * Two cards, because that is the commonest number and the point is to reserve roughly the right space, not to
 * predict it. `aria-busy` with a spoken label does the announcing; the blocks themselves are decoration.
 */
export function LoyaltyOffersSkeleton() {
    const { t } = useTranslation();

    return (
        <div className="flex flex-col gap-6" aria-busy="true" aria-live="polite">
            <span className="sr-only">{t('status.loading')}</span>

            <div className="flex flex-col items-center gap-2">
                <Skeleton className="h-8 w-40" />
                <Skeleton className="h-6 w-28" />
            </div>

            <div className="flex flex-col gap-2">
                <Skeleton className="h-5 w-28" />

                {[0, 1].map((index) => (
                    <div key={index} className="overflow-hidden rounded-xl border border-border">
                        {/* The same 3:2 block the real card uses, so nothing shifts when it arrives. */}
                        <Skeleton className="aspect-[3/2] w-full rounded-none" />

                        <div className="flex flex-col gap-2 p-3">
                            <Skeleton className="h-5 w-2/3" />
                            <Skeleton className="h-4 w-full" />
                            <Skeleton className="h-4 w-1/2" />
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}
